document.addEventListener("DOMContentLoaded", function() {
  const faqButtons = document.querySelectorAll(".faq-question");
  let lastOpened = null;

  if (faqButtons.length > 0) {
    faqButtons[0].setAttribute("aria-expanded", "true");
    faqButtons[0].querySelector(".faq-toggle-icon").textContent = "×";
    faqButtons[0].nextElementSibling.style.display = "block";
    lastOpened = faqButtons[0];
  }

  faqButtons.forEach(button => {
    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      const icon = button.querySelector(".faq-toggle-icon");

      if (lastOpened && lastOpened !== button) {
        lastOpened.setAttribute("aria-expanded", "false");
        lastOpened.querySelector(".faq-toggle-icon").textContent = "+";
        lastOpened.nextElementSibling.style.display = "none";
      }

      if (expanded) {
        button.setAttribute("aria-expanded", "false");
        icon.textContent = "+";
        button.nextElementSibling.style.display = "none";
        lastOpened = null;
      } else {
        button.setAttribute("aria-expanded", "true");
        icon.textContent = "×";
        button.nextElementSibling.style.display = "block";
        lastOpened = button;
      }
    });
  });
});